module.exports = __webpack_public_path__ + "static/media/video.be4912e5.webm";